__turbopack_context__.v({
  "hide-arrows": "k2AyAa_hide-arrows",
});
